import { AppConstants } from '../constants/app-constants';

export class AppLocalStorage {

	static setToken(token: string) {
		localStorage.setItem(AppConstants.SESSION_TOKEN, token);
	}

	static getToken() {
		return localStorage.getItem(AppConstants.SESSION_TOKEN);
	}

	static logout() {
		localStorage.removeItem(AppConstants.SESSION_TOKEN);
		localStorage.removeItem(AppConstants.ROLE);
		localStorage.removeItem(AppConstants.THEME);
		localStorage.removeItem(AppConstants.USER);
		sessionStorage.removeItem('weekly-plan-carousel-seen');
	}
}
